var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1103 9.42004L11.9736 11.5168C12.0274 11.6475 11.9974 11.7976 11.8975 11.8975C11.7976 11.9974 11.6475 12.0274 11.5168 11.9736L9.42004 11.1103L11.1103 9.42004Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19473 2.20498C3.46805 1.93167 3.91117 1.93167 4.18448 2.20498L4.97459 2.99509L5.02773 2.94194C5.5647 2.40497 6.4353 2.40497 6.97227 2.94194L8.26517 4.23483C8.41161 4.38128 8.41161 4.61872 8.26517 4.76517C8.11872 4.91161 7.88128 4.91161 7.73484 4.76517L6.44194 3.47227C6.19787 3.22819 5.80214 3.22819 5.55806 3.47227L5.50492 3.52542L10.7245 8.7452L8.7452 10.7245L2.20498 4.18448C1.93167 3.91117 1.93167 3.46805 2.20498 3.19473L3.19473 2.20498Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5H9.8074C9.76026 5.17102 9.68845 5.33667 9.59196 5.49132L11.1599 7.05932C11.2661 7.02093 11.3806 7 11.5 7H19C19.5523 7 20 7.44772 20 8C20 8.55229 19.5523 9 19 9H12.5529L12.5686 9.02232L13.3606 10.9457C13.368 10.9637 13.3752 10.9818 13.382 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H12.9149C12.3874 13.4945 11.6176 13.6373 10.9457 13.3607L9.02228 12.5687L7.15415 11.2548L2.14647 6.2473C2.05203 6.47964 2 6.73375 2 7V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5ZM20 16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16C4 15.4477 4.44772 15 5 15H19C19.5523 15 20 15.4477 20 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAlt);
export default __webpack_public_path__ + "static/media/check-alt.502fed2aadfab0ee95a25d8ad5e1795c.svg";
export { ForwardRef as ReactComponent };